import {siteURL} from "../WooCommerce/wooConfig";

const addToCart = (e, databaseId, productQty, setAddedToCart, hire = 0) => {
    e.preventDefault();
    setAddedToCart({
        loading: true,
    });
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'charset': 'UTF-8' },
        body: `product_id=${databaseId}&quantity=${productQty}`
    };
    if (hire) requestOptions.body +=  '&hire_product=hire_product';
    fetch(`${siteURL}/?wc-ajax=add_to_cart`, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                setAddedToCart({
                    loading: false,
                    added: true
                });
                const basketCount = document.querySelector('[data-basket-count]'),
                    miniCart = document.querySelector('[data-mini-cart]');
                if(basketCount && result.fragments) basketCount.innerHTML = result.fragments.cartCount;
                if(miniCart && result.fragments) miniCart.innerHTML = result.fragments.cartContents;
                setTimeout(() => {
                    setAddedToCart({
                        loading: false,
                        added: false
                    });
                }, 2000);
            },
            (error) => {
                setAddedToCart({
                    loading: false,
                    error: true
                });
            }
        )
};

export default addToCart;